export const MATCHED_APPS_REGION = 'contextDetail.matchedApps.region';
export const MATCHED_PAGES_REGION = 'contextDetail.matchedPages.region';
export const MATCHED_VIDEOS_REGION = 'contextDetail.matchedVideos.region';

export const autoDealProviderTypes = ['xandr', 'iristv'];
